import { render, staticRenderFns } from "./BoothTypeImage.vue?vue&type=template&id=745c8b94"
import script from "./BoothTypeImage.vue?vue&type=script&lang=ts"
export * from "./BoothTypeImage.vue?vue&type=script&lang=ts"
import style0 from "./BoothTypeImage.vue?vue&type=style&index=0&id=745c8b94&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports